module.exports = __webpack_public_path__ + "static/media/Collapse.77b8e2ea.svg";